import { GenericSetting, PortalSettingMap } from '../Types/portal';
import { get, getQSFromObject } from './common';

const apiGenericSettingPath = 'api/genericsetting/';

export function getPortalSetting<K extends keyof PortalSettingMap>(key: K): PortalSettingMap[K] {
	const value = window.portalSettings[key];
	return value as PortalSettingMap[K];
}

export async function getGenericSettings(type: string, keys: string[]) {
	const path = `${apiGenericSettingPath}GetGenericSettings?${getQSFromObject({ type: type, keys })}`;
	return await get<GenericSetting[]>(path);
}
